import { Division } from '@la/types';
import { capitalizeFirstLetter } from '@la/utilities';

export const getInvalidCostErrorMessage = (subProgramLabel: string) =>
  `${capitalizeFirstLetter(subProgramLabel)} cost is not a valid value.`;

/**
 * Retrieves cost of division, which is an optional registration setting
 * for a given Division.
 * @param division The division to get the cost from.
 * @returns The cost of the division, defaulting to 0 if no cost is specified.
 */
export const getDivisionCost = (division: Division): number => {
  const cost = division.cost ? Number(division.cost) : 0;

  if (isNaN(cost)) {
    throw new Error(
      `${capitalizeFirstLetter(division.subProgramLabel)} cost is not a valid value.`
    );
  }

  return cost;
};

export const isFree = (max: string): boolean => {
  const maxValue = Number(max);

  if (isNaN(maxValue)) {
    throw new Error('Value provided is not a number.');
  }

  return maxValue === 0;
};
